// Mantem o subtotal e a barra de frete gratis do mini-cart iguais ao carrinho real:
// - a barra nao era atualizada em alguns caminhos (ex.: adicao pelo "Compre Junto")
// - depois de uma cotacao de frete, /cart/change.js devolve total_price com o frete
//   somado, e o mini-cart exibia esse valor como "Subtotal"
(function () {
  var miniCart = document.getElementById('miniCart');
  if (!miniCart || !window.MutationObserver) return;

  var lastSubtotal = null;
  var timer = null;

  function money(value) {
    return 'R$ ' + value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function fixSubtotal(cart) {
    var el = document.getElementById('miniCartSubtotal');
    if (!el) return;
    var shownCents = parseInt(el.textContent.replace(/\D/g, ''), 10);
    if (shownCents === cart.total_price) return;
    el.textContent = money(cart.total_price / 100);
    lastSubtotal = el.textContent.trim();
  }

  function updateBar(cart) {
    var container = miniCart.querySelector('.mini-cart__progress-bar');
    if (!container) return;
    var bar = container.querySelector('.cart-progressbar');
    var fill = container.querySelector('.progress');
    var dot = container.querySelector('.progress-dot');
    if (!bar || !fill) return;

    var current = cart.total_price / 100;
    var steps = Array.prototype.map.call(bar.querySelectorAll('.progress-step'), function (el) {
      return {
        el: el,
        value: parseFloat(el.dataset.step),
        text: el.dataset.text || '',
        position: parseFloat(el.style.getPropertyValue('--position') || '100')
      };
    }).filter(function (s) { return !isNaN(s.value); });
    if (!steps.length) return;

    var progress = 0, next = null, prevPos = 0, prevVal = 0;
    for (var i = 0; i < steps.length; i++) {
      var step = steps[i];
      if (current < step.value) {
        next = step;
        progress = prevPos + ((current - prevVal) / (step.value - prevVal)) * (step.position - prevPos);
        break;
      }
      prevPos = step.position;
      prevVal = step.value;
    }
    if (!next) progress = steps[steps.length - 1].position;

    bar.dataset.currentValue = current;
    bar.style.setProperty('--progress-width', progress + '%');
    fill.style.width = progress + '%';
    if (dot) dot.style.left = progress + '%';
    steps.forEach(function (s) {
      s.el.classList.toggle('progress-step-active', current >= s.value);
    });

    var lead = next ? 'Adicione mais ' + money(next.value - current) + ' para ganhar' : 'Parabéns! Você ganhou';
    var reward = next ? next.text : steps.map(function (s) { return s.text; }).join(' e ');

    var promo = container.querySelector('.promotional-text');
    var congrats = container.querySelector('.congratulations-text');
    if (promo) {
      promo.style.display = 'block';
      var instigator = promo.querySelector('.instigator');
      var promotion = promo.querySelector('.promotion');
      if (instigator) instigator.textContent = lead;
      if (promotion) {
        promotion.style.fontWeight = next ? '' : 'bold';
        promotion.textContent = reward;
      }
      if (congrats) congrats.style.display = 'none';
    } else if (congrats) {
      congrats.textContent = lead + ' ';
      var b = document.createElement('b');
      b.textContent = reward;
      congrats.appendChild(b);
    }
  }

  function check() {
    var el = document.getElementById('miniCartSubtotal');
    var text = el ? el.textContent.trim() : '';
    if (!text || text === lastSubtotal) return;
    lastSubtotal = text;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        fixSubtotal(cart);
        updateBar(cart);
      })
      .catch(function () {});
  }

  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(check, 150);
  }).observe(miniCart, { childList: true, subtree: true, characterData: true });
})();
